import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractPageHandler } from './page-handler-abstract';

export class PageNotFoundHandler extends AbstractPageHandler {
  private router = inject(Router);

  override async handle(): Promise<any | null> {
    this.router.navigateByUrl('/not-found', {
      onSameUrlNavigation: 'reload',
      skipLocationChange: true,
    });

    return null;
  }
}
